export function insertAtCursor(input, token) {
    const s = input.selectionStart, e = input.selectionEnd;
    input.setRangeText(token, s, e, 'end');
    input.dispatchEvent(new Event('input'));
    input.focus();
}
